(() => {
  class ProjectSlider {
    constructor(wrapper) {
      this.wrapper = wrapper;
      this.sliderWrapper = wrapper.querySelector(".swiper");
      this.lines = this.wrapper.querySelectorAll(".lines > .line");
      this.progress = 0;

      // init slider
      this._init();
    }

    _init() {
      this.wrapper.classList.add("initialized");

      this.__recreateSlider();

      // update slider on resize
      window.addEventListener("resize", () => {
        this.__recreateSlider();
      });

      document.addEventListener("click", (e) => {
        const projectLink = e.target.closest(".project-slide");
        if (projectLink) {
          const projectSlide = projectLink.closest(".swiper-slide");
          projectSlide.classList.add("is-tranforming-to-main-image");
        }
      });
    }

    __recreateSlider() {
      if (this.instance) {
        this.instance.destroy();
      }

      const containerWidth = this.sliderWrapper.offsetWidth;

      const args = {
        loop: false,
        freeMode: {
          enabled: true,
          momentum: true,
        },
        mousewheel: true,
        // slides width will be calculated automatically
        slidesPerView: "auto",
        // Add (in px) additional slide offset in the beginning of the container (before all slides)
        slidesOffsetBefore: containerWidth * 0.22,
        // Add (in px) additional slide offset in the end of the container (after all slides)
        slidesOffsetAfter: containerWidth * 0.22,
        // gap between slides
        spaceBetween: containerWidth * 0.05,
      };

      this.instance = new window.Swiper(this.sliderWrapper, args);

      this.instance.on("progress", (slider, progress) => {
        this.progress = progress;
      });
      this.instance.on("setTranslate", this._updateLines.bind(this));
      this._updateLines();
    }

    _updateLines() {
      // const steps = 9;
      const step = 0.111111111111111; //1 / steps;

      this.lines.forEach((line, index) => {
        const idealValue = index * step;
        const distanceToIdealValue = idealValue - this.progress;
        const yValue =
          distanceToIdealValue < 0
            ? distanceToIdealValue * -90
            : distanceToIdealValue * 90;
        line.style.transform = `translateY(${yValue}%)`;
      });
    }
  }

  window?.luther?.eventBus?.on("luther:pageContentRemoved", () => {
    window.luther.projectSlider.forEach((slider) => {
      slider.instance.destroy();
    });
    window.luther.projectSlider = null;
  });

  window?.luther?.eventBus?.on(
    "luther:pageContentChange",
    updateLutherProjectSlidersInstances,
  );

  function updateLutherProjectSlidersInstances() {
    const newProjectSliders = document.querySelectorAll(
      ".luther-project-slider:not(.initialized)",
    );
    newProjectSliders.forEach((el) => {
      window.luther.projectSlider = new ProjectSlider(el);
    });
  }

  window.luther = window.luther || {};
  window.luther.projectSlider = null;
  window.luther.projectSliderUpdater = updateLutherProjectSlidersInstances;

  document.addEventListener(
    "DOMContentLoaded",
    updateLutherProjectSlidersInstances,
  );
})();
